const domainModel = require('domain-model');
const _ = require('lodash');

function recalculateIncreaseInput(value, sku, possibleToSetAnyValue) {
  if (value <= 0) {
    return 0;
  }

  if (possibleToSetAnyValue) {
    return _.round(value, 2);
  }

  if (sku.minOrderQuantity && value < sku.minOrderQuantity) {
    return _.round(sku.minOrderQuantity, 2);
  }

  if (sku.stepOrderIncrement) {
    return _.round(
      Math.ceil(value / sku.stepOrderIncrement) * sku.stepOrderIncrement,
      2,
    );
  }
  return _.round(value, 2);
}

function recalculateDecreaseInput(value, sku, possibleToSetAnyValue) {
  if (value <= 0) {
    return 0;
  }

  if (possibleToSetAnyValue) {
    return domainModel.math.roundDown(value, 2);
  }

  if (sku.minOrderQuantity && value < sku.minOrderQuantity) {
    return 0;
  }

  if (sku.stepOrderIncrement) {
    return domainModel.math.roundDown(
      (value / sku.stepOrderIncrement) * sku.stepOrderIncrement,
      2,
    );
  }
  return domainModel.math.roundDown(value, 2);
}

module.exports = {
  recalculateDecreaseInput,
  recalculateIncreaseInput,
};
